export enum TestIds {
  ImpactId = 'ImpactId',
  RatedItemId = 'RatedItemId',
  CompletedBy = 'CompletedBy',
  Rating = 'Rating',
  TestDate = 'TestDate',
  Likelihood = 'Likelihood',
}
